import { getToken, setToken, removeToken } from '@/utils/auth';
import userApi from '@/api/common';

const getUserInfo = () => {
  const defaultState = {//基本信息
    group_name:"",
    mobile: "",
    password: "",
    realname: "",
    role: "",
    role_name:"",
    username: ""
  };

  const userInfoStr = localStorage.getItem('userInfo');
  if (userInfoStr === null) {
    return defaultState;
  } else {
    return JSON.parse(userInfoStr);
  }
};

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUserInfo(),
    roleList:[],//角色列表
    subjectsList:[]
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());//重置数据
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  SET_ROLE_LIST:(state,roleList)=>{
    state.roleList = roleList
  },
  SET_SUBJECT_LIST:(state,subjectsList)=>{
    state.subjectsList = subjectsList
  }
};

const actions = {
  async login({ commit, state }, userInfo) {
    const { username, password } = userInfo;

    // 拿到jwt token
    const loginData = await userApi.login({
      username,
      password,
    });

    if (loginData.code !== 200) {
      return {
        code: loginData.code,
        message: loginData.message,
      };
    }

    // 通过mutation方法去改变state里面数据（参数解构）
    commit('SET_TOKEN', 'Bearer ' + loginData.data.access_token);
    setToken('Bearer ' + loginData.data.access_token);

    // 通过token拿到用户个人信息
    const userInfoData = await userApi.tobMe();
    let _info = userInfoData.data
    if(userInfoData.data.password){
        delete _info.password
    }
    commit('SET_USER_INFO', _info);

    return {
      code: 200,
    };
  },

  async logout({ commit, state }) {
    removeToken();
    commit('RESET_STATE');

    return true;
  },

  async roleList({ commit,state }){
    let _role
    if(sessionStorage.getItem('roleList')){
        _role = JSON.parse(sessionStorage.getItem('roleList'))
    }else{
        const res = await userApi.roleList()
        _role = res.data
        sessionStorage.setItem('roleList',JSON.stringify(_role))
    }
    commit('SET_ROLE_LIST',_role)
  },

  async subjectsList({ commit,state }){
    let _role
    if(sessionStorage.getItem('subjectsList')){
        _role = JSON.parse(sessionStorage.getItem('subjectsList'))
    }else{
        const res = await userApi.subjectsList({cate_id:1399})
        _role = res.data.data
        sessionStorage.setItem('subjectsList',JSON.stringify(_role))
    }
    commit('SET_SUBJECT_LIST',_role)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
